import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesome } from '../../FontAwesome';

import './styles.scss';

export class ReduxFormSubmitButton extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  render() {
    const { label, submitting } = this.props;
    const icon = submitting ? 'spinner' : null;
    const iconProps = submitting ? { spin: true } : {};

    return (
      <button type="submit" className="btn-submit">
        {icon && <FontAwesome name={icon} {...iconProps} />}
        {label && <span>{label}</span>}
      </button>
    );
  }
}
